import { Check as LucideCheckIcon } from "lucide-react";
import type { DsIcon } from "./types";
import { iconVariants } from "./variants-icon";

export const CheckIcon: DsIcon = (props) => {
  return <LucideCheckIcon className={iconVariants(props)} />;
};
